import React from 'react'
import Sidebar from './components/Sidebar'

import HomePage from './pages/HomePage'

// Routing
import { Route, Switch, useLocation } from 'react-router-dom'

import ProjectInfoET from './components/ProjectInfoET'
import ProjectInfoSeed from './components/ProjectInfoSeed'
import ProjectInfoGraphinTunes from './components/ProjectInfoGraphinTunes'
import ProjectInfoSN from './components/ProjectInfoSN'
import ProjectInfoNatours from './components/ProjectInfoNatours'

// Animations and Style
import GlobalStyle from './components/GlobalStyle'
import { motion } from 'framer-motion'
import styled from 'styled-components'

// Scroll and Animations
import { pageAnimation } from './components/Animation'
import { AnimatePresence } from 'framer-motion'
import ProjectInfoWYS from './components/ProjectInfoWYS'

const App = () => {
    const location = useLocation()
    window.onbeforeunload = function () {
        window.scrollTo({
            top: 10,
            left: 10,
        })
    }

    return (
        <Container>
            <GlobalStyle />
            <Flex>
                <Left>
                    <Sidebar />
                </Left>
                <Right
                    className="about-us"
                    variants={pageAnimation}
                    initial="hidden"
                    animate="show"
                    exit="exit"
                >
                    <AnimatePresence exitBeforeEnter>
                        <Switch location={location} key={location.pathname}>
                            <Route path="/" exact>
                                <motion.div
                                    variants={pageAnimation}
                                    initial="hidden"
                                    animate="show"
                                    exit="exit"
                                >
                                    <HomePage />
                                </motion.div>
                            </Route>
                            <Route path="/projects/graphin-tunes">
                                <ProjectInfoGraphinTunes />
                            </Route>
                            <Route path="/projects/natours">
                                <ProjectInfoNatours />
                            </Route>
                            <Route path="/projects/examtantra">
                                <ProjectInfoET />
                            </Route>
                            <Route path="/projects/seed">
                                <ProjectInfoSeed />
                            </Route>
                            <Route path="/projects/serenity-now">
                                <ProjectInfoSN />
                            </Route>
                            <Route path="/projects/watch-your-spend">
                                <ProjectInfoWYS />
                            </Route>
                        </Switch>
                    </AnimatePresence>
                </Right>
            </Flex>
        </Container>
    )
}

const Container = styled(motion.div)`
    min-height: 100vh;
    margin-right: -1rem;
`
const Flex = styled.div`
    display: grid;
    grid-template-columns: 0.6fr 8fr;
    min-height: 100vh;
`

const Left = styled.div`
    min-height: 100vh;
`

const Right = styled(motion.div)``

export default App
